<template>
  <div class="newRemit">
    <v-card class="pa-10" flat>
      <v-card-title class="pa-0">
        {{ $route.name == 'NewRemit' ? '建立匯款單' : '修改匯款單' }}
      </v-card-title>
      <v-divider class="mb-5"></v-divider>
      
      <v-row>
        <v-col>
          <v-subheader>主播</v-subheader>
        </v-col>
        <v-col>
          <v-select 
            :items="sellers" 
            item-value="id"
            dense 
            placeholder="選擇主播" 
            v-model="remit.seller_id"
            :rules="[$rules.integer]"
          >
            <template v-slot:item="{ item }">
              <v-avatar size="30" class="mr-2">
                <v-img :src="$HOST_URL + item.usericon"/>
              </v-avatar>
              <span>{{ item.nickname }}</span>
            </template>
            <template v-slot:selection="{ item }">
              <v-avatar size="20" class="mr-1">
                <v-img :src="$HOST_URL + item.usericon"/>
              </v-avatar>
              <span>{{ item.nickname }}</span>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader class="pink--text">桃子總數</v-subheader>
        </v-col>
        <v-col class="d-flex">
          <div class="peach mt-2"></div>
          <v-text-field 
            dense 
            v-model="seller.peach_wallet"
            readonly
          ></v-text-field>
          <v-subheader class="pink--text">換算台幣總數</v-subheader>
          <v-text-field 
            dense 
            :value="$func.peach2price(seller.peach_wallet).toFixed(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader class="pink--text">主播抽成</v-subheader>
        </v-col>
        <v-col class="d-flex">
          <v-text-field 
            dense 
            :value="seller.personal_commission * 100"
            :rules="[$rules.integer]"
            readonly
          ></v-text-field>
          %
          <v-subheader class="pink--text">主播提款上限</v-subheader>
            <v-text-field 
              dense 
              :value="($func.peach2price(seller.peach_wallet) * seller.personal_commission).toFixed(2)"
              readonly
            ></v-text-field>
          
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader>銀行名稱</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="remit.bank" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader>銀行分行</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="remit.bank_branch" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader>銀行帳號</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="remit.account_number" :rules="[$rules.integer]"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader>提款金額 (TWD)</v-subheader>
        </v-col>
        <v-col class="d-flex">
          <v-text-field dense v-model="remit.amount" :rules="[rules.validAmount]"></v-text-field>
          <v-subheader class="pink--text">應扣除桃子</v-subheader>
          <div class="peach mt-2"></div>
          <v-text-field dense readonly :value="parseInt(remit.amount / seller.personal_commission * 43)"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="seller" class="mt-4">
        <v-col>
          <v-subheader>備註</v-subheader>
        </v-col>
        <v-textarea v-model="remit.remark" outlined></v-textarea>
      </v-row>

      <v-row v-if="seller">
        <v-col>
          <v-subheader>經手人</v-subheader>
        </v-col>
        <v-col>
          <v-text-field dense v-model="remit.handler" :rules="[$rules.notEmpty]"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-6">
        <v-btn block dark color="indigo" @click="formIsValid ? $root.$emit('confirmDialog', submit, `確定為 <span class='pink--text'>${seller.nickname}</span> 申請提款 <span class='pink--text'>${remit.amount}</span> ？`, 'fa-dollar-sign') : ''">送出</v-btn>
      </v-row>

    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sellers: [],
      remit: {
        seller_id: '',
        bank: '',
        bank_branch: '',
        account_number: '',
        amount: '',
        remark: '',
        handler: ''
      },
      rules: {
        validAmount: value => value <= this.$func.peach2price(this.seller.peach_wallet) * this.seller.personal_commission && value > 0
      }
    }
  },
  created() {
    this.getSellers()
  },
  computed: {
    seller() {
      return this.sellers.find(seller => seller.id == this.remit.seller_id)
    },
    formIsValid() {
      return (
        this.$rules.notEmpty(this.remit.bank) &&
        this.$rules.notEmpty(this.remit.bank_branch) &&
        this.$rules.notEmpty(this.remit.account_number) &&
        this.rules.validAmount(this.remit.amount) &&
        this.$rules.notEmpty(this.remit.handler)
      )
    }
  },
  watch: {
    'remit.seller_id'(newValue) {
      this.remit.bank = this.seller.bank
      this.remit.bank_branch = this.seller.bank_branch
      this.remit.account_number = this.seller.account_number
    }
  },
  methods: {
    getSellers() {
      this.axios.post('/admin/sellers', {
        search: [],
        page: 1,
        size: 999999
      }).then(response => {
        this.sellers = response.data.data.map(seller => {
          seller.disabled = false
          return seller
        })
      })
    },
    submit() {
      if(!this.formIsValid) {
        return
      }
      this.axios.post('/admin/account/remit', this.remit).then(response => {
        this.$root.$emit('alert', 'success', '建立匯款單成功')
        this.$router.push('/admin/remittance')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '建立匯款單失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.newRemit {
  .row {
    align-items: center;
    & > div:first-child {
      flex-grow: 0;
      min-width: 140px;
    }
    & > div:nth-child(2) {
      max-width: 800px;
    }
  }
  .v-subheader {
    white-space: nowrap;
  }
}
</style>